<template>

  <v-dialog

    v-model="dialog"

    :persistent="requiredMode"

    max-width="820"

    scrollable

  >

    <!--
      ÖNEMLİ:
      v-dialog kapalıyken içerik DOM'a render edilirse, manuel yardım
      bölümündeki YouTube iframe'i de yüklenebilir.
      Bu da LocalStorage'da onay olsa bile gereksiz YouTube isteği oluşturur.

      Dialog gerçekten açılmadan içeriği render etmiyoruz.
      Böylece:
      - Kullanıcı ilk kez girmediyse bile popup açılana kadar YouTube isteği yok.
      - LocalStorage'da onay varsa popup hiç açılmaz ve YouTube isteği oluşmaz.
      - ? yardım butonuna basılırsa video normal şekilde yüklenir.
    -->
    <v-card v-if="dialog" class="pricing-notice-card">

      <!-- =============================================================

           YENİ FİYATLANDIRMA BİLGİLENDİRMESİ

           requiredMode = true:

           - Rezervasyon Ekle butonundan ilk girişte kullanılır.

           - 5 saniye okuma süresi vardır.

           - İlk bilgi adımından sonra video adımı zorunludur.

           - Video URL tanımlıysa video bitmeden onay butonu açılmaz.

           - Kullanıcı dialogu X ile kapatamaz.

           requiredMode = false:

           - Rezervasyon Kalemleri ekranındaki ? butonundan açılır.

           - Sayaç yoktur.

           - Bilgi ve video aynı ekranda gösterilir.

           - Kullanıcı istediği zaman kapatabilir.

           ============================================================= -->

      <!-- ZORUNLU İLK GÖSTERİM - 1. ADIM -->

      <template v-if="requiredMode && step === 1">

        <div class="pricing-notice-hero">

          <div class="pricing-notice-icon pricing-notice-icon-important">

            <v-icon>campaign</v-icon>

          </div>

          <div class="pricing-notice-title-wrap">

            <span class="pricing-notice-eyebrow">ÖNEMLİ YENİLİK</span>

            <h2>Yeni Fiyatlandırma Sistemi</h2>

            <p>

              Yeni Kotasyon Formu ve Yeni Satış Raporunun doğru hesaplama

              yapabilmesi için rezervasyon kalemlerindeki fiyat giriş yöntemi

              güncellenmiştir.

            </p>

          </div>

        </div>

        <v-card-text class="pricing-notice-body">

          <div class="pricing-main-message">

            <div class="pricing-main-message-icon">

              <v-icon>priority_high</v-icon>

            </div>

            <div>

              <span>Fiyat girişi yaparken</span>

              <strong>Maliyet ve satış kalemlerine KDV dahil TOPLAM tutar girilmelidir.</strong>

            </div>

          </div>

          <div class="pricing-rule-grid">

            <div class="pricing-rule-card pricing-rule-pax">

              <div class="pricing-rule-card-head">

                <span class="pricing-rule-badge">PAX</span>

                <v-icon>people</v-icon>

              </div>

              <h3>Kişi bazlı hesaplama</h3>

              <p>

                Toplam tutar girilir. Birim fiyat hesaplanırken kişi sayısı

                esas alınır. Oda / araç / adet bilgisi ayrıca hesaba katılmaz.

              </p>

              <div class="pricing-example">

                <small>ÖRNEK</small>

                <b>3 kişi · 3.000 TL toplam satış</b>

                <span>Birim satış: 3.000 ÷ 3 = 1.000 TL</span>

              </div>

            </div>

            <div class="pricing-rule-card pricing-rule-fix">

              <div class="pricing-rule-card-head">

                <span class="pricing-rule-badge">FIX</span>

                <v-icon>business_center</v-icon>

              </div>

              <h3>Oda / araç / adet bazlı hesaplama</h3>

              <p>

                Toplam tutar girilir. Birim fiyat hesaplanırken hizmetin oda,

                araç veya adet bilgisi esas alınır. Kişi sayısı ayrıca hesaba katılmaz.

              </p>

              <div class="pricing-example">

                <small>ÖRNEK · OTEL</small>

                <b>2 gece · 3 oda · 3.000 TL</b>

                <span>Birim fiyat: 3.000 ÷ 2 ÷ 3 = 500 TL</span>

              </div>

            </div>

          </div>

          <div class="pricing-products-info">

            <div class="pricing-products-icon">

              <v-icon>auto_awesome</v-icon>

            </div>

            <div>

              <strong>Yeni sistemi ne zaman kullanmalıyım?</strong>

              <p>

                Bu yöntemle girilen rezervasyonlarda <b>Yeni Kotasyon Formu</b>

                ve <b>Yeni Satış Raporu</b> kullanılmalıdır. Eski çalışma düzenini

                kullanmak isteyen kullanıcılar mevcut Kotasyon Formu ve mevcut

                Satış Raporunu kullanmaya devam edebilir.

              </p>

            </div>

          </div>

          <div class="pricing-memory-note">

            <v-icon small>verified_user</v-icon>

            <span>

              Bilgilendirme ve video adımını tamamladıktan sonra onayınız bu

              kullanıcı için bu tarayıcıda hatırlanacaktır.

            </span>

          </div>

        </v-card-text>

        <v-card-actions class="pricing-notice-actions pricing-notice-actions-centered">

          <v-btn

            color="info"

            dark

            large

            class="pricing-primary-btn pricing-countdown-btn"

            :class="{ 'pricing-countdown-btn-disabled': countdown > 0 }"

            :aria-disabled="countdown > 0 ? 'true' : 'false'"

            @click="goToVideo"

          >

            <v-icon left>check_circle</v-icon>

            <span v-if="countdown > 0">Okudum ve Anladım ({{ countdown }})</span>

            <span v-else>Onaylıyorum</span>

          </v-btn>

        </v-card-actions>

      </template>

      <!-- ZORUNLU İLK GÖSTERİM - 2. ADIM / VIDEO -->

      <template v-else-if="requiredMode && step === 2">

        <div class="pricing-notice-hero pricing-video-hero">

          <div class="pricing-notice-icon pricing-notice-icon-video">

            <v-icon>play_circle_filled</v-icon>

          </div>

          <div class="pricing-notice-title-wrap">

            <span class="pricing-notice-eyebrow">2 / 2 · KISA EĞİTİM</span>

            <h2>Nasıl Kullanılır?</h2>

            <p>

              Yeni fiyat giriş yöntemini kısa videoda izleyin. Video tamamen

              tamamlandıktan sonra kapatma / onay butonu aktif olacaktır.

            </p>

          </div>

        </div>

        <v-card-text class="pricing-notice-body">

          <div v-if="hasVideo" class="pricing-video-shell">

            <!--

              YouTube videosu doğrudan <video> etiketiyle oynatılamaz.

              Bu alan YouTube IFrame Player API tarafından doldurulur.

              Video tamamen bittiğinde handleVideoEnded() tetiklenir.

            -->

            <div

              ref="requiredYoutubePlayer"

              class="pricing-youtube-player"

            ></div>

          </div>

          <!--

               YOUTUBE VIDEO TANIMLANMADIYSA:

               Aşağıdaki placeholder gösterilir.

               youtubeVideoId tanımlı olduğunda bu fallback otomatik kalkar ve

               zorunlu akışta video tamamen bitmeden onay süreci başlamaz.

          -->

          <div v-else class="pricing-video-placeholder">

            <div class="pricing-video-placeholder-icon">

              <v-icon>ondemand_video</v-icon>

            </div>

            <strong>Eğitim videosu için alan hazır</strong>

            <p>

              Video adresi eklendiğinde kullanıcı bu ekranda videoyu izleyecek ve

              video bitmeden zorunlu onay butonu aktif olmayacaktır.

            </p>

          </div>

                    <div class="pricing-video-watch-notice">
            <div class="pricing-video-watch-notice-icon">
              <v-icon>lock_clock</v-icon>
            </div>
            <div>
              <strong>Videoyu tamamen izlemeniz gerekmektedir.</strong>
              <span>
                Video tamamlanmadan <b>“İzledim, Anladım ve Onaylıyorum”</b>
                butonu aktif olmayacaktır.
              </span>
            </div>
          </div>

<div class="pricing-video-reminder">

            <v-icon small>info</v-icon>

            <span>

              Hatırlatma: Maliyet ve satış kalemlerine <b>KDV dahil toplam tutar</b>

              girilmelidir.

            </span>

          </div>

        </v-card-text>

        <v-card-actions class="pricing-notice-actions">

          <v-btn flat color="grey" @click="backToExplanation">

            <v-icon left small>arrow_back</v-icon>

            Açıklamaya Dön

          </v-btn>

          <v-spacer></v-spacer>

          <v-btn

            color="success"

            dark

            large

            class="pricing-primary-btn pricing-video-countdown-btn"

            :class="{

              'pricing-countdown-btn-disabled':

                (hasVideo && !videoEnded) || videoConfirmCountdown > 0

            }"

            :aria-disabled="

              ((hasVideo && !videoEnded) || videoConfirmCountdown > 0)

                ? 'true'

                : 'false'

            "

            @click="completeRequiredNotice"

          >

            <v-icon left>verified</v-icon>

            <span v-if="hasVideo && !videoEnded">
              Video Tamamlanınca Aktif Olacak
            </span>
            <span v-else-if="videoConfirmCountdown > 0">
              İzledim, Anladım ve Onaylıyorum ({{ videoConfirmCountdown }})
            </span>
            <span v-else>İzledim, Anladım ve Onaylıyorum</span>

          </v-btn>

        </v-card-actions>

      </template>

      <!-- MANUEL YARDIM MODU - ? BUTONU -->

      <template v-else>

        <div class="pricing-notice-hero pricing-help-hero">

          <div class="pricing-notice-icon pricing-notice-icon-help">

            <v-icon>help_outline</v-icon>

          </div>

          <div class="pricing-notice-title-wrap">

            <span class="pricing-notice-eyebrow">YENİ FİYATLANDIRMA YARDIMI</span>

            <h2>Toplam Tutar Giriş Rehberi</h2>

            <p>

              Bu yöntemle oluşturulan rezervasyonlarda <b>Yeni Kotasyon Formu</b>

              ve <b>Yeni Satış Raporu</b> kullanılmalıdır. Eski çalışma düzeniyle

              devam etmek isteyen kullanıcılar mevcut Kotasyon Formu ve mevcut

              Satış Raporunu kullanmaya devam edebilir.

            </p>

          </div>

          <v-btn icon class="pricing-close-btn" @click="close">

            <v-icon>close</v-icon>

          </v-btn>

        </div>

        <v-card-text class="pricing-notice-body">

          <div class="pricing-help-summary">

            <v-icon>priority_high</v-icon>

            <div>

              <strong>Maliyet ve satış kalemlerine KDV dahil TOPLAM tutar girin.</strong>

              <span>

                PAX işleminde kişi sayısı, FIX işleminde hizmetin oda / araç / adet bilgisi

                birim fiyat hesabında kullanılır.

              </span>

            </div>

          </div>

          <div class="pricing-help-rule-row">

            <div>

              <span class="pricing-mini-badge pricing-mini-pax">PAX</span>

              <b>Kişi bazlı</b>

              <small>Oda / araç / adet ayrıca bölene eklenmez.</small>

            </div>

            <div>

              <span class="pricing-mini-badge pricing-mini-fix">FIX</span>

              <b>Oda / araç / adet bazlı</b>

              <small>Kişi sayısı ayrıca bölene eklenmez.</small>

            </div>

          </div>

          <div v-if="hasVideo" class="pricing-help-video-section">

            <div class="pricing-help-video-title">

              <v-icon>play_circle_outline</v-icon>

              <div>

                <strong>Nasıl Kullanılır?</strong>

                <span>Yeni fiyat giriş sistemini tekrar izleyebilirsiniz.</span>

              </div>

            </div>

            <div class="pricing-video-shell">

              <iframe

                class="pricing-youtube-iframe"

                :src="youtubeEmbedUrl"

                title="Yeni Fiyatlandırma Eğitim Videosu"

                frameborder="0"

                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"

                allowfullscreen

              ></iframe>

            </div>

          </div>

          <div v-else class="pricing-help-video-section">

            <div class="pricing-help-video-title">

              <v-icon>play_circle_outline</v-icon>

              <div>

                <strong>Nasıl Kullanılır?</strong>

                <span>Video alanı hazır; video adresi daha sonra eklenecek.</span>

              </div>

            </div>

            <div class="pricing-video-placeholder pricing-video-placeholder-small">

              <v-icon>ondemand_video</v-icon>

              <span>Eğitim videosu yakında burada görünecek.</span>

            </div>

          </div>

        </v-card-text>

        <v-card-actions class="pricing-notice-actions">

          <v-spacer></v-spacer>

          <v-btn color="info" dark class="pricing-primary-btn" @click="close">

            <v-icon left small>check</v-icon>

            Tamam

          </v-btn>

        </v-card-actions>

      </template>

    </v-card>

  </v-dialog>

</template>

<script>

export default {

  name: "YeniFiyatlandirmaBilgi",

  data() {

    return {

      dialog: false,

      requiredMode: false,

      step: 1,

      countdown: 5,

      countdownTimer: null,

      confirmCountdown: 5,

      confirmCountdownTimer: null,

      videoConfirmCountdown: 5,

      videoConfirmCountdownTimer: null,

      videoStarted: false,

      videoEnded: false,

      // ================================================================

      // EĞİTİM VİDEOSU - YOUTUBE

      // ================================================================

      // Eğitim videosu:

      // https://youtu.be/zXSkgKfZMI4

      //

      // YouTube linki normal <video src=""> olarak kullanılamaz.

      // Zorunlu akışta YouTube IFrame Player API kullanılır.

      // Video gerçekten SONUNA geldiğinde ikinci 5 saniyelik onay

      // sayacı başlar.

      //

      // Manuel yardım ekranında aynı video iframe olarak gösterilir.

      // ================================================================

      youtubeVideoId: "zXSkgKfZMI4",

      youtubePlayer: null,

      youtubeApiPollTimer: null,

      youtubePlayerReady: false,

      youtubeLoadTimeoutTimer: null

    };

  },

  computed: {

    hasVideo() {

      return !!(

        this.youtubeVideoId &&

        this.youtubeVideoId.toString().trim()

      );

    },

    youtubeEmbedUrl() {

      if (!this.hasVideo) {

        return "";

      }

      return (

        "https://www.youtube.com/embed/" +

        this.youtubeVideoId +

        "?rel=0&modestbranding=1&playsinline=1"

      );

    }

  },

  beforeDestroy() {

    this.clearCountdown();

    this.clearConfirmCountdown();

    this.clearVideoConfirmCountdown();

    this.clearYoutubeLoadTimeout();

    this.clearYoutubeApiPoll();

    this.destroyYoutubePlayer();

  },

  methods: {

    /**

     * İlk rezervasyon girişinde çağrılır.

     * 5 saniyelik zorunlu okuma + video akışını başlatır.

     */

    // ================================================================
    // YENİ FİYATLANDIRMA - LOCALSTORAGE KONTROLÜ
    // ================================================================
    // Kullanıcı bu bilgilendirmeyi daha önce tamamladıysa YouTube'u
    // tekrar yüklemiyoruz. Böylece ilk gösterimden sonraki rezervasyon
    // girişlerinde gereksiz YouTube isteği ve bekleme oluşmaz.
    //
    // Anahtar, rezervasyon listesinde kullanılan anahtarla aynıdır.
    // Kullanıcı bazlı + versiyonludur.
    // ================================================================
    yeniFiyatlandirmaStorageKey() {

      var credentials = null;

      try {

        credentials = JSON.parse(
          window.localStorage.getItem("credentials")
        );

      } catch (e) {

        credentials = null;

      }

      var userId =
        credentials &&
        credentials.UserID !== null &&
        credentials.UserID !== undefined
          ? credentials.UserID
          : "unknown";

      return "coper_yeni_fiyatlandirma_bilgi_v1_user_" + userId;

    },

    yeniFiyatlandirmaOnayliMi() {

      return (
        window.localStorage.getItem(
          this.yeniFiyatlandirmaStorageKey()
        ) === "1"
      );

    },

    /**
     * İlk rezervasyon girişinde çağrılır.
     *
     * ÖNEMLİ:
     * Kullanıcı daha önce bilgilendirmeyi tamamladıysa burada hemen
     * çıkılır. Bu durumda popup açılmaz, sayaç çalışmaz ve YouTube
     * IFrame API / video isteği başlatılmaz.
     */
    openRequired() {

      // Kullanıcı daha önce onayladıysa hiçbir şey yükleme.
      // Parent sayfa da aynı kontrolü yapıyor; buradaki kontrol
      // ekstra güvenlik ve gereksiz YouTube isteğini engellemek içindir.
      if (this.yeniFiyatlandirmaOnayliMi()) {

        this.$emit("completed");

        return;

      }

      this.resetState();

      this.requiredMode = true;

      this.dialog = true;

      this.startCountdown();

    },

    /**

     * Rezervasyon Kalemleri ekranındaki ? butonundan çağrılır.

     * Sayaç ve zorunlu onay olmadan bilgi + video gösterilir.

     */

    openHelp() {

      this.resetState();

      this.requiredMode = false;

      this.dialog = true;

    },

    resetState() {

      this.clearCountdown();

      this.clearConfirmCountdown();

      this.clearVideoConfirmCountdown();

      this.step = 1;

      this.countdown = 5;

      this.confirmCountdown = 5;

      this.videoConfirmCountdown = 5;

      this.videoStarted = false;

      this.videoEnded = false;

    },

    startCountdown() {

      this.clearCountdown();

      this.countdown = 5;

      this.countdownTimer = window.setInterval(() => {

        if (this.countdown > 0) {

          this.countdown -= 1;

        }

        if (this.countdown <= 0) {

          this.clearCountdown();

        }

      }, 1000);

    },

    startConfirmCountdown() {

      this.clearConfirmCountdown();

      this.confirmCountdown = 5;

      this.confirmCountdownTimer = window.setInterval(() => {

        if (this.confirmCountdown > 0) {

          this.confirmCountdown -= 1;

        }

        if (this.confirmCountdown <= 0) {

          this.clearConfirmCountdown();

        }

      }, 1000);

    },

    clearConfirmCountdown() {

      if (this.confirmCountdownTimer) {

        window.clearInterval(this.confirmCountdownTimer);

        this.confirmCountdownTimer = null;

      }

    },

    startVideoConfirmCountdown() {

      this.clearVideoConfirmCountdown();

      this.videoConfirmCountdown = 5;

      this.videoConfirmCountdownTimer = window.setInterval(() => {

        if (this.videoConfirmCountdown > 0) {

          this.videoConfirmCountdown -= 1;

        }

        if (this.videoConfirmCountdown <= 0) {

          this.clearVideoConfirmCountdown();

        }

      }, 1000);

    },

    clearVideoConfirmCountdown() {

      if (this.videoConfirmCountdownTimer) {

        window.clearInterval(this.videoConfirmCountdownTimer);

        this.videoConfirmCountdownTimer = null;

      }

    },

    clearCountdown() {

      if (this.countdownTimer) {

        window.clearInterval(this.countdownTimer);

        this.countdownTimer = null;

      }

    },

    goToVideo() {

      if (this.countdown > 0) {

        return;

      }

      this.step = 2;

      this.videoStarted = false;

      this.videoEnded = false;

      this.youtubePlayerReady = false;

      this.clearYoutubeLoadTimeout();

      if (!this.hasVideo) {

        this.startVideoConfirmCountdown();

        return;

      }

      // YouTube 5 saniye içinde hazır olmazsa kullanıcıyı bekletme.
      this.startYoutubeLoadTimeout();

      this.$nextTick(() => {

        this.initRequiredYoutubePlayer();

      });

    },

    //==================================================================

    // YOUTUBE IFRAME PLAYER API

    //==================================================================

    startYoutubeLoadTimeout() {

      this.clearYoutubeLoadTimeout();

      this.youtubeLoadTimeoutTimer = window.setTimeout(() => {

        if (this.youtubePlayerReady || this.videoEnded) {
          this.clearYoutubeLoadTimeout();
          return;
        }

        this.handleYoutubeLoadTimeout();

      }, 5000);

    },

    clearYoutubeLoadTimeout() {

      if (this.youtubeLoadTimeoutTimer) {
        window.clearTimeout(this.youtubeLoadTimeoutTimer);
        this.youtubeLoadTimeoutTimer = null;
      }

    },

    handleYoutubeLoadTimeout() {

      this.clearYoutubeLoadTimeout();
      this.clearYoutubeApiPoll();
      this.destroyYoutubePlayer();

      // YouTube teknik olarak açılamadıysa kullanıcıyı kilitleme.
      // Akışı onaylanmış kabul edip pencereyi tamamla.
      this.videoStarted = true;
      this.videoEnded = true;
      this.videoConfirmCountdown = 0;

      this.completeRequiredNotice();

    },

    loadYoutubeApi() {

      return new Promise((resolve) => {

        if (window.YT && window.YT.Player) {

          resolve(window.YT);

          return;

        }

        var existingScript = document.getElementById(

          "youtube-iframe-api-script"

        );

        if (!existingScript) {

          var script = document.createElement("script");

          script.id = "youtube-iframe-api-script";

          script.src = "https://www.youtube.com/iframe_api";

          script.async = true;

          document.head.appendChild(script);

        }

        this.clearYoutubeApiPoll();

        this.youtubeApiPollTimer = window.setInterval(() => {

          if (window.YT && window.YT.Player) {

            this.clearYoutubeApiPoll();

            resolve(window.YT);

          }

        }, 100);

      });

    },

    clearYoutubeApiPoll() {

      if (this.youtubeApiPollTimer) {

        window.clearInterval(this.youtubeApiPollTimer);

        this.youtubeApiPollTimer = null;

      }

    },

    destroyYoutubePlayer() {

      this.clearYoutubeLoadTimeout();

      if (

        this.youtubePlayer &&

        typeof this.youtubePlayer.destroy === "function"

      ) {

        try {

          this.youtubePlayer.destroy();

        } catch (e) {

          // Player zaten kaldırılmış olabilir.

        }

      }

      this.youtubePlayer = null;

    },

    initRequiredYoutubePlayer() {

      if (!this.hasVideo || !this.$refs.requiredYoutubePlayer) {

        return;

      }

      this.destroyYoutubePlayer();

      this.loadYoutubeApi().then((YT) => {

        if (

          !this.dialog ||

          !this.requiredMode ||

          this.step !== 2 ||

          !this.$refs.requiredYoutubePlayer

        ) {

          return;

        }

        this.youtubePlayer = new YT.Player(

          this.$refs.requiredYoutubePlayer,

          {

            videoId: this.youtubeVideoId,

            width: "100%",

            height: "420",

            playerVars: {

              rel: 0,

              modestbranding: 1,

              playsinline: 1,

              controls: 1

            },

            events: {

              onReady: () => {

                this.youtubePlayerReady = true;
                this.clearYoutubeLoadTimeout();

              },

              onError: () => {

                this.handleYoutubeLoadTimeout();

              },

              onStateChange: (event) => {

                if (

                  window.YT &&

                  event.data === window.YT.PlayerState.PLAYING

                ) {

                  this.videoStarted = true;

                }

                if (

                  window.YT &&

                  event.data === window.YT.PlayerState.ENDED

                ) {

                  this.handleVideoEnded();

                }

              }

            }

          }

        );

      });

    },

    backToExplanation() {

      this.destroyYoutubePlayer();

      this.clearYoutubeApiPoll();

      this.clearVideoConfirmCountdown();

      this.videoStarted = false;

      this.videoEnded = false;

      this.youtubePlayerReady = false;

      this.clearYoutubeLoadTimeout();

      this.videoConfirmCountdown = 5;

      this.step = 1;

    },

    handleVideoEnded() {

      this.videoEnded = true;

      this.startVideoConfirmCountdown();

    },

    completeRequiredNotice() {

      if ((this.hasVideo && !this.videoEnded) || this.videoConfirmCountdown > 0) {

        return;

      }

      this.dialog = false;

      this.clearCountdown();

      // LocalStorage kaydını parent sayfa yapar.

      // Böylece kullanıcı anahtarı / versiyon bilgisi rezervasyon listesinde yönetilir.

      this.$emit("completed");

    },

    close() {

      // İlk zorunlu gösterim dışarıdan kapatılamaz.

      if (this.requiredMode) {

        return;

      }

      this.dialog = false;

      this.clearCountdown();
      this.clearYoutubeLoadTimeout();
      this.clearYoutubeApiPoll();

    }

  }

};

</script>

<style scoped>

.pricing-notice-card {

  overflow: hidden;

  border-radius: 18px !important;

  background: #ffffff;

}

.pricing-notice-hero {

  position: relative;

  display: flex;

  align-items: flex-start;

  gap: 16px;

  padding: 25px 28px 21px;

  border-bottom: 1px solid #e7edf4;

  background: linear-gradient(135deg, #fff8ef 0%, #fffdf9 58%, #f7fbff 100%);

}

.pricing-video-hero {

  background: linear-gradient(135deg, #eef8ff 0%, #f9fcff 100%);

}

.pricing-help-hero {

  background: linear-gradient(135deg, #f3f8ff 0%, #fbfdff 100%);

}

.pricing-notice-icon {

  width: 52px;

  height: 52px;

  flex: 0 0 52px;

  display: flex;

  align-items: center;

  justify-content: center;

  border-radius: 15px;

  background: #ffffff;

  box-shadow: 0 8px 22px rgba(31, 41, 55, 0.09);

}

.pricing-notice-icon .v-icon {

  font-size: 27px;

}

.pricing-notice-icon-important .v-icon { color: #f08a25; }

.pricing-notice-icon-video .v-icon { color: #238bd4; }

.pricing-notice-icon-help .v-icon { color: #397cc3; }

.pricing-notice-title-wrap {

  min-width: 0;

  padding-right: 35px;

}

.pricing-notice-eyebrow {

  display: block;

  margin-bottom: 4px;

  color: #e47b18;

  font-size: 10px;

  line-height: 14px;

  font-weight: 800;

  letter-spacing: 1.25px;

}

.pricing-video-hero .pricing-notice-eyebrow,

.pricing-help-hero .pricing-notice-eyebrow {

  color: #2685c8;

}

.pricing-notice-title-wrap h2 {

  margin: 0;

  color: #202a39;

  font-size: 22px;

  line-height: 29px;

  font-weight: 750;

}

.pricing-notice-title-wrap p {

  max-width: 650px;

  margin: 7px 0 0;

  color: #748195;

  font-size: 12px;

  line-height: 19px;

}

.pricing-close-btn {

  position: absolute !important;

  top: 13px;

  right: 13px;

  color: #8592a4 !important;

}

.pricing-notice-body {

  padding: 22px 28px !important;

}

.pricing-main-message {

  display: flex;

  align-items: center;

  gap: 12px;

  padding: 14px 16px;

  border: 1px solid #ffe0bd;

  border-radius: 12px;

  background: #fff9f1;

}

.pricing-main-message-icon {

  width: 34px;

  height: 34px;

  flex: 0 0 34px;

  display: flex;

  align-items: center;

  justify-content: center;

  border-radius: 9px;

  background: #ffedd6;

}

.pricing-main-message-icon .v-icon {

  color: #ef8a22;

  font-size: 19px;

}

.pricing-main-message span,

.pricing-main-message strong {

  display: block;

}

.pricing-main-message span {

  margin-bottom: 2px;

  color: #9a7550;

  font-size: 10px;

}

.pricing-main-message strong {

  color: #51381f;

  font-size: 13px;

  line-height: 19px;

}

.pricing-rule-grid {

  display: grid;

  grid-template-columns: 1fr 1fr;

  gap: 14px;

  margin-top: 16px;

}

.pricing-rule-card {

  padding: 16px;

  border: 1px solid #e5ebf2;

  border-radius: 13px;

  background: #fbfcfe;

}

.pricing-rule-pax { border-top: 3px solid #258ddc; }

.pricing-rule-fix { border-top: 3px solid #7259c8; }

.pricing-rule-card-head {

  display: flex;

  align-items: center;

  justify-content: space-between;

}

.pricing-rule-card-head .v-icon {

  color: #98a4b5;

  font-size: 21px;

}

.pricing-rule-badge,

.pricing-mini-badge {

  display: inline-flex;

  align-items: center;

  justify-content: center;

  border-radius: 999px;

  color: #fff;

  font-size: 9px;

  font-weight: 800;

  letter-spacing: 0.65px;

}

.pricing-rule-badge {

  min-width: 48px;

  padding: 4px 9px;

  background: #258ddc;

}

.pricing-rule-fix .pricing-rule-badge { background: #7259c8; }

.pricing-rule-card h3 {

  margin: 12px 0 5px;

  color: #2b3545;

  font-size: 14px;

}

.pricing-rule-card p {

  min-height: 55px;

  margin: 0;

  color: #727f92;

  font-size: 10px;

  line-height: 17px;

}

.pricing-example {

  margin-top: 12px;

  padding: 10px 11px;

  border-radius: 9px;

  background: #ffffff;

  border: 1px solid #e7edf4;

}

.pricing-example small,

.pricing-example b,

.pricing-example span {

  display: block;

}

.pricing-example small {

  color: #9aa5b4;

  font-size: 8px;

  font-weight: 700;

  letter-spacing: 0.55px;

}

.pricing-example b {

  margin-top: 3px;

  color: #374357;

  font-size: 10px;

}

.pricing-example span {

  margin-top: 3px;

  color: #68778c;

  font-size: 10px;

}

.pricing-products-info {

  display: flex;

  align-items: flex-start;

  gap: 11px;

  margin-top: 16px;

  padding: 13px 14px;

  border-radius: 11px;

  border: 1px solid #dfeaf4;

  background: #f5faff;

}

.pricing-products-icon {

  width: 32px;

  height: 32px;

  flex: 0 0 32px;

  display: flex;

  align-items: center;

  justify-content: center;

  border-radius: 9px;

  background: #e5f3ff;

}

.pricing-products-icon .v-icon {

  color: #258bd3;

  font-size: 18px;

}

.pricing-products-info strong {

  color: #324157;

  font-size: 11px;

}

.pricing-products-info p {

  margin: 4px 0 0;

  color: #6d7b8f;

  font-size: 10px;

  line-height: 16px;

}

.pricing-memory-note {

  display: flex;

  align-items: center;

  gap: 7px;

  margin-top: 13px;

  color: #7d8999;

  font-size: 9px;

}

.pricing-memory-note .v-icon { color: #3ca06d; }

.pricing-notice-actions {

  padding: 14px 22px !important;

  border-top: 1px solid #edf1f5;

  background: #fafbfd;

}

.pricing-notice-actions-centered {

  justify-content: center !important;

}

.pricing-primary-btn {

  min-height: 42px !important;

  border-radius: 9px !important;

  text-transform: none !important;

  letter-spacing: 0 !important;

  font-weight: 650 !important;

}

.pricing-video-shell {

  overflow: hidden;

  width: 100%;

  border-radius: 13px;

  background: #10151d;

  box-shadow: 0 8px 24px rgba(20, 31, 45, 0.13);

}

.pricing-video {

  display: block;

  width: 100%;

  max-height: 430px;

  background: #10151d;

}

.pricing-video-placeholder {

  min-height: 260px;

  display: flex;

  flex-direction: column;

  align-items: center;

  justify-content: center;

  padding: 28px;

  text-align: center;

  border: 1px dashed #bed2e3;

  border-radius: 13px;

  background: #f6faff;

}

.pricing-video-placeholder-icon {

  width: 56px;

  height: 56px;

  display: flex;

  align-items: center;

  justify-content: center;

  margin-bottom: 12px;

  border-radius: 15px;

  background: #e5f2fc;

}

.pricing-video-placeholder .v-icon {

  color: #3287c5;

  font-size: 28px;

}

.pricing-video-placeholder strong {

  color: #334257;

  font-size: 13px;

}

.pricing-video-placeholder p {

  max-width: 520px;

  margin: 7px 0 0;

  color: #788598;

  font-size: 10px;

  line-height: 17px;

}

.pricing-video-reminder {

  display: flex;

  align-items: center;

  gap: 7px;

  margin-top: 13px;

  padding: 10px 12px;

  border-radius: 9px;

  background: #fff8ed;

  color: #7d674c;

  font-size: 10px;

}

.pricing-video-reminder .v-icon { color: #e58a2f; }

.pricing-help-summary {

  display: flex;

  align-items: flex-start;

  gap: 10px;

  padding: 13px 14px;

  border-radius: 11px;

  background: #fff9f0;

  border: 1px solid #f8dfbd;

}

.pricing-help-summary > .v-icon {

  color: #e98a2b;

}

.pricing-help-summary strong,

.pricing-help-summary span {

  display: block;

}

.pricing-help-summary strong {

  color: #4f3b26;

  font-size: 11px;

}

.pricing-help-summary span {

  margin-top: 3px;

  color: #806c55;

  font-size: 10px;

  line-height: 16px;

}

.pricing-help-rule-row {

  display: grid;

  grid-template-columns: 1fr 1fr;

  gap: 12px;

  margin-top: 13px;

}

.pricing-help-rule-row > div {

  padding: 11px 12px;

  border: 1px solid #e5ebf2;

  border-radius: 10px;

  background: #fbfcfe;

}

.pricing-help-rule-row b,

.pricing-help-rule-row small {

  display: block;

}

.pricing-help-rule-row b {

  margin-top: 6px;

  color: #384558;

  font-size: 10px;

}

.pricing-help-rule-row small {

  margin-top: 3px;

  color: #7b8798;

  font-size: 9px;

}

.pricing-mini-badge {

  min-width: 40px;

  padding: 3px 8px;

}

.pricing-mini-pax { background: #258ddc; }

.pricing-mini-fix { background: #7259c8; }

.pricing-help-video-section {

  margin-top: 15px;

  padding-top: 14px;

  border-top: 1px solid #edf1f5;

}

.pricing-help-video-title {

  display: flex;

  align-items: center;

  gap: 8px;

  margin-bottom: 9px;

}

.pricing-help-video-title .v-icon {

  color: #2989cc;

}

.pricing-help-video-title strong,

.pricing-help-video-title span {

  display: block;

}

.pricing-help-video-title strong {

  color: #334156;

  font-size: 11px;

}

.pricing-help-video-title span {

  margin-top: 2px;

  color: #8792a3;

  font-size: 9px;

}

.pricing-video-placeholder-small {

  min-height: 100px;

  flex-direction: row;

  gap: 9px;

  padding: 18px;

}

.pricing-video-placeholder-small .v-icon {

  font-size: 22px;

}

.pricing-video-placeholder-small span {

  color: #768497;

  font-size: 10px;

}

@media (max-width: 700px) {

  .pricing-notice-hero,

  .pricing-notice-body {

    padding-left: 18px !important;

    padding-right: 18px !important;

  }

  .pricing-rule-grid,

  .pricing-help-rule-row {

    grid-template-columns: 1fr;

  }

  .pricing-rule-card p {

    min-height: auto;

  }

  .pricing-notice-actions {

    flex-wrap: wrap;

  }

}













/* =========================================================

   GERİ SAYIM BUTONU - HER ZAMAN GÖRÜNÜR

   =========================================================

   Vuetify'nin disabled stilini kullanmıyoruz.

   Çünkü bazı proje/global temalarda disabled v-btn görsel olarak

   görünmez hale gelebiliyor.

   Sayaç devam ederken:

   - Buton ekranda kalır.

   - Gri görünür.

   - Cursor not-allowed olur.

   - Click metodu kendi guard'ı sayesinde ilerlemez.

   Sayaç bittiğinde:

   - Aynı buton mavi / aktif görünüme döner.

   ========================================================= */

.pricing-countdown-btn,

.pricing-video-countdown-btn {

    min-width: 270px !important;

    min-height: 44px !important;

    opacity: 1 !important;

    visibility: visible !important;

    display: inline-flex !important;

    transition: background .20s ease, box-shadow .20s ease, transform .20s ease !important;

}

.pricing-countdown-btn-disabled {

    background: #a7b2bf !important;

    border-color: #a7b2bf !important;

    color: #ffffff !important;

    opacity: 1 !important;

    visibility: visible !important;

    pointer-events: auto !important;

    cursor: not-allowed !important;

    box-shadow: none !important;

}

.pricing-countdown-btn-disabled .v-icon,

.pricing-countdown-btn-disabled .v-btn__content,

.pricing-countdown-btn-disabled span {

    color: #ffffff !important;

    opacity: 1 !important;

}

.pricing-countdown-btn:not(.pricing-countdown-btn-disabled),

.pricing-video-countdown-btn:not(.pricing-countdown-btn-disabled) {

    background: #2196f3 !important;

    border-color: #2196f3 !important;

    color: #ffffff !important;

    box-shadow: 0 5px 14px rgba(33, 150, 243, .30) !important;

    cursor: pointer !important;

}

.pricing-countdown-btn:not(.pricing-countdown-btn-disabled):hover,

.pricing-video-countdown-btn:not(.pricing-countdown-btn-disabled):hover {

    transform: translateY(-1px);

    box-shadow: 0 7px 18px rgba(33, 150, 243, .34) !important;

}

@media (max-width: 600px) {

    .pricing-countdown-btn,

    .pricing-video-countdown-btn {

        width: 100% !important;

        min-width: 0 !important;

    }

}





.pricing-youtube-player,

.pricing-youtube-iframe {

  display: block;

  width: 100%;

  height: 420px;

  border: 0;

  background: #10151d;

}

.pricing-youtube-player iframe {

  display: block;

  width: 100% !important;

  height: 420px !important;

  border: 0;

}

@media (max-width: 700px) {

  .pricing-youtube-player,

  .pricing-youtube-iframe,

  .pricing-youtube-player iframe {

    height: 230px !important;

  }

}



.pricing-video-watch-notice {
  margin-top: 14px;
  padding: 13px 14px;
  display: flex;
  align-items: center;
  gap: 11px;
  border: 1px solid #cfe4f5;
  border-radius: 11px;
  background: linear-gradient(90deg, #f2f9ff 0%, #f8fcff 100%);
}

.pricing-video-watch-notice-icon {
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  background: #dcefff;
}

.pricing-video-watch-notice-icon .v-icon {
  color: #2789d0;
  font-size: 19px;
}

.pricing-video-watch-notice strong,
.pricing-video-watch-notice span {
  display: block;
}

.pricing-video-watch-notice strong {
  color: #2f4860;
  font-size: 11px;
  line-height: 15px;
}

.pricing-video-watch-notice span {
  margin-top: 3px;
  color: #6f8193;
  font-size: 10px;
  line-height: 15px;
}

</style>